export default __webpack_public_path__ + "static/media/category.587657cf.svg";